<script setup>
// NOTICE: KAPTION-INTEGRATION
// ai-connectors.CLIENTS.1: an AI tool's official mark in a bordered tile;
// falls back to a plug icon for tools we don't recognise.
import { computed } from 'vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { findAiClient } from './kaptionAiClients';

const props = defineProps({
  clientId: { type: String, default: '' },
  size: { type: String, default: 'md' }, // sm | md | lg
});

const client = computed(() => findAiClient(props.clientId));
const box = computed(
  () =>
    ({
      sm: 'size-8 rounded-lg',
      md: 'size-10 rounded-lg',
      lg: 'size-12 rounded-xl',
    })[props.size]
);
const fill = computed(() =>
  client.value?.color === '#000000' ? 'currentColor' : client.value?.color
);
</script>

<template>
  <span
    class="flex items-center justify-center flex-shrink-0 border border-n-weak bg-n-solid-1 text-n-slate-12"
    :class="box"
    aria-hidden="true"
  >
    <svg v-if="client" viewBox="0 0 24 24" class="size-[58%]">
      <path :d="client.path" :fill="fill" />
    </svg>
    <Icon v-else icon="i-lucide-plug-zap" class="size-5 text-n-slate-11" />
  </span>
</template>
